import React, { Component } from 'react';

import Icon from '../icon/icon';

import './_button.scss';

export default class Button extends Component {
    render (props) {
        const classNames = [
            'btn',
            `btn--${props.kind || 'primary'}`
        ];

        // Disambbiguate children as it may be a string (which also has length)
        const childrenArray = React.Children.toArray(props.children);
        const children = [];

        if (props.iconPrefix) {
            if (props.iconPrefix === 'loader') {
                children.push(<span className="icon btn__loader" />);
            } else {
                children.push(<Icon id={ props.iconPrefix } />);
            }
        }

        if (childrenArray.length) {
            children.push(<span>{ childrenArray[0] }</span>);
        }

        if (props.icon) {
            children.push(<Icon id={ props.icon } />);
        }

        // TODO: Instead of prop just check if no href and click handler?
        if (props.inert) {
            return <div class={ classNames.join(' ') }>{ children }</div>;
        }

        if (props.href) {
            return (
                <a class={ classNames.join(' ') } href={ props.href }>
                    { children }
                </a>
            );
        }

        return (
            <button
                type="button"
                class={ classNames.join(' ') }
                disabled={ props.disabled }
                title={ props.title }
                onClick={ props.handleClick }
            >
                { children }
            </button>
        );
    }
}
